export const common = {
  // Navigation
  nav_features: '功能',
  nav_security: '安全',
  nav_community: '社区',
  nav_join: '立即加入',
  nav_back_home: '返回首页',
  
  // Hero Section
  hero_title: 'FaceTrue',
  hero_subtitle: '身份验证社交网络',
  hero_description_1: '没有假账户。没有欺凌。没有暴力。',
  hero_description_2: '没有毒性。没有极端主义。',
  hero_description_3: '100%积极 - AI验证。',
  
  // How It Works
  how_title: '工作原理',
  step1_title: '面部验证',
  step1_desc: '拍摄自拍照 → AI验证身份 → 即时验证',
  step1_badge: '没有假账户',
  step2_title: '清洁内容',
  step2_desc: 'AI全天候过滤有毒、欺诈、暴力内容',
  step2_badge: 'AI过滤24/7',
  step3_title: '全球社区',
  step3_desc: '国内或全球发布',
  step3_badge: '世界各国',
  
  // Age-Based Content
  age_title: '年龄适宜内容',
  children_label: '儿童',
  children_title: '儿童专区',
  children_feature1: '安全教育内容',
  children_feature2: '友好环境',
  children_feature3: '家长监督',
  adults_label: '成人',
  adults_title: '成人专区',
  adults_feature1: '社交讨论',
  adults_feature2: '职业与生活',
  adults_feature3: '全球连接',
  seniors_label: '老年人',
  seniors_title: '老年人专区',
  seniors_feature1: '健康信息',
  seniors_feature2: '分享经验',
  seniors_feature3: '支持社区',
  
  // Why Different
  why_title: '为什么选择FaceTrue',
  why_feature1_title: '100%真人',
  why_feature1_desc: 'AI身份验证，消除假账户',
  why_feature2_title: '无暴力和毒性',
  why_feature2_desc: 'AI全天候过滤暴力、有毒、欺凌内容',
  why_feature3_title: '无极端主义',
  why_feature3_desc: '消除所有形式的极端主义和仇恨',
  why_feature4_title: '100%积极',
  why_feature4_desc: '只有积极、建设性和健康的内容',
  why_feature5_title: '所有年龄段安全',
  why_feature5_desc: '智能内容分类，适合每个年龄段',
  why_feature6_title: '三旗警告系统',
  why_feature6_desc: '黄旗（第1次违规）→ 红旗（第2次违规）→ 黑旗（第3次违规 - 账户锁定）',
  why_feature7_title: '星级评分系统',
  why_feature7_desc: '分享积极信息、图片、视频 → 从社区获得粉色心形星星',
  why_feature8_title: '真实广告',
  why_feature8_desc: 'AI检查广告真实性。产品在发布前验证来源',
  
  // Video Demo
  video_title: 'FaceTrue演示视频',
  video_subtitle: '查看工作原理',
  video_views: '次观看',
  video_close: '点击X关闭',
  video_demo_live: '演示直播',
  video_info: '模拟FaceTrue演示',
  video_info_cta: '点击播放观看演示',
  video_update: '真实视频将从Veo AI更新',
  
  // Video Stages
  scanning_title: '正在验证...',
  scanning_desc: 'AI正在检查身份',
  scanning_step1: '检测到面部',
  scanning_step2: 'AI验证',
  scanning_step3: '创建个人资料...',
  scanning_badge: '100%真人',
  
  intro_step1_title: '验证成功',
  intro_step1_subtitle: '100%真人',
  intro_step2_title: 'AI内容过滤',
  intro_step2_subtitle: '无毒性，无暴力',
  intro_step3_title: '全球连接',
  intro_step3_subtitle: '119个国家',
  intro_step4_title: '100%积极',
  intro_step4_subtitle: '只有健康内容',
  intro_step5_title: '所有年龄段安全',
  intro_step5_subtitle: '儿童 • 成人 • 老年人',
  
  stats_title: 'FaceTrue社区',
  stats_subtitle: '强劲增长',
  stats_users: '用户',
  stats_countries: '国家',
  stats_posts: '积极帖子',
  stats_badge: '100%积极',
  
  comparison_title: '差异',
  comparison_old: '旧社交媒体',
  comparison_old_1: '假账户',
  comparison_old_2: '有毒内容',
  comparison_old_3: '暴力',
  comparison_old_4: '欺诈',
  comparison_new: 'FaceTrue',
  comparison_new_1: '100%真人',
  comparison_new_2: '清洁内容',
  comparison_new_3: '100%积极',
  comparison_new_4: 'AI安全',
  
  // CTA Section
  cta_title: '立即加入',
  cta_subtitle: '注册FaceTrue测试版',
  cta_name: '全名',
  cta_email: '您的电子邮件',
  cta_button: '立即注册',
  cta_submitting: '提交中...',
  cta_success: '🎉 谢谢！我们会尽快联系您。',
  cta_error: '❌ 发生错误。请重试。',
  cta_privacy: '我们尊重您的隐私',
  
  // Footer
  footer_copyright: '© 2025 FaceTrue全球社交网络',
  footer_creator: '由Ben Nguyen创建',
  footer_powered: '网站建设者',
  
  // Time
  time_hours_ago: '小时前',
  time_day_ago: '天前',
  
  // Children Page
  children_nav_features: '特色',
  children_nav_safety: '安全',
  children_nav_activities: '活动',
  children_back_home: '返回首页',
  
  children_hero_title: '欢迎来到',
  children_hero_subtitle: '小天使们',
  children_hero_desc: '专为儿童设计的安全、有趣和教育空间！<br />100%家长认可的内容，配备AI保护。',
  children_explore_btn: '探索功能',
  children_safety_btn: '安全第一',
  
  children_features_title: '有趣且富有教育意义的功能',
  children_features_subtitle: '儿童安全学习、玩耍和成长所需的一切',
  
  children_feature1_title: '教育内容',
  children_feature1_desc: '适合年龄的学习材料、有趣的测验和互动课程，让教育变得有趣。',
  
  children_feature2_title: '安全游戏',
  children_feature2_desc: '精心挑选的游戏，既有趣又富有教育意义，对儿童完全安全。',
  
  children_feature3_title: '创意活动',
  children_feature3_desc: '绘画、涂色、讲故事和其他创意活动，激发想象力。',
  
  children_safety_title: '您孩子的安全是首要任务',
  children_safety_subtitle: '多层保护确保无忧体验',
  
  children_safety1_title: 'AI内容过滤',
  children_safety1_desc: '24/7 AI监控确保只有适当的内容到达儿童。',
  
  children_safety2_title: '家长控制',
  children_safety2_desc: '家长可以监控活动并设置健康的屏幕时间限制。',
  
  children_safety3_title: '无陌生人',
  children_safety3_desc: '儿童只能与经过验证的朋友和家人互动。',
  
  children_activities_title: '探索有趣的活动',
  children_activities_subtitle: '点击任何活动了解更多并开始玩耍！',
  
  // 8 Activities
  activity1_title: '绘画与艺术',
  activity1_desc: '使用数字工具创作精美艺术作品',
  
  activity2_title: '教育游戏',
  activity2_desc: '通过互动游戏边玩边学',
  
  activity3_title: '故事与阅读',
  activity3_desc: '通过故事探索神奇世界',
  
  activity4_title: '音乐与歌曲',
  activity4_desc: '发现有趣的歌曲和旋律',
  
  activity5_title: '照片与视频',
  activity5_desc: '捕捉和分享特殊时刻',
  
  activity6_title: '团体活动',
  activity6_desc: '与朋友一起玩耍和学习',
  
  activity7_title: '挑战与奖励',
  activity7_desc: '完成有趣的挑战并获得奖励',
  
  activity8_title: '特别活动',
  activity8_desc: '参加激动人心的季节性活动',
  
  children_footer_copyright: '© 2025 FaceTrue儿童区',
  children_footer_desc: '儿童学习和玩耍的安全空间',
  
  children_modal_safe_badge: '安全有趣',
  children_modal_what_you_can_do: '你可以做什么',
  children_modal_start_btn: '开始活动',
  
  // Adults Page
  adults_nav_features: '功能',
  adults_nav_community: '社区',
  adults_nav_benefits: '优势',
  adults_back_home: '返回首页',
  adults_hero_title: '连接',
  adults_hero_subtitle: '真实的人，真实的故事',
  adults_hero_desc: '加入经过验证的成人社区，分享真实体验，<br />建立有意义的联系，共同成长。',
  adults_explore_btn: '探索功能',
  adults_join_btn: '加入社区',
  adults_features_title: '连接所需的一切',
  adults_features_subtitle: '专业网络、生活方式分享和有意义的对话',
  adults_feature1_title: '职业与专业',
  adults_feature1_desc: '与专业人士建立联系，分享职业见解，发现您领域的机会。',
  adults_feature2_title: '生活方式与兴趣',
  adults_feature2_desc: '与全球志同道合的人分享您的激情、爱好和日常生活。',
  adults_feature3_title: '深度对话',
  adults_feature3_desc: '与经过验证的用户就您关心的话题进行有意义的讨论。',
  adults_community_title: '加入全球社区',
  adults_community_subtitle: '与分享您兴趣和价值观的人联系',
  adults_community_entrepreneurs: '企业家',
  adults_community_entrepreneurs_desc: '商业想法和创业讨论',
  adults_community_health: '健康与保健',
  adults_community_health_desc: '健身、营养和心理健康',
  adults_community_arts: '艺术与文化',
  adults_community_arts_desc: '创意表达和文化交流',
  adults_community_travel: '旅行与冒险',
  adults_community_travel_desc: '分享经验和旅行技巧',
  adults_community_food: '美食与烹饪',
  adults_community_food_desc: '食谱、餐厅和烹饪艺术',
  adults_community_technology: '技术',
  adults_community_technology_desc: '技术趋势和创新',
  adults_community_parenting: '育儿',
  adults_community_parenting_desc: '家庭生活和育儿技巧',
  adults_community_education: '教育',
  adults_community_education_desc: '学习和个人发展',
  adults_community_active: '活跃社区',
  adults_community_join_btn: '加入社区',
  adults_benefits_title: '为什么成人选择FaceTrue',
  adults_benefits_subtitle: '为真实成人连接而建的社交网络',
  adults_benefit1_title: '经过验证的身份',
  adults_benefit1_desc: '自信地连接，知道每个人都是真实的。',
  adults_benefit2_title: '无毒性',
  adults_benefit2_desc: 'AI过滤消除骚扰、仇恨言论和负面内容。',
  adults_benefit3_title: '全球覆盖',
  adults_benefit3_desc: '与全球119个国家的经过验证的用户连接。',
  adults_benefit4_title: '隐私优先',
  adults_benefit4_desc: '您的数据受到企业级安全措施的保护。',
  adults_footer_copyright: '© 2025 FaceTrue成人社区',
  adults_footer_desc: '与全球经过验证的成人真实连接',
  
  // Seniors Page
  seniors_nav_features: '功能',
  seniors_nav_health: '健康',
  seniors_nav_community: '社区',
  seniors_back_home: '返回首页',
  seniors_hero_title: '社区',
  seniors_hero_subtitle: '为老年人而建',
  seniors_hero_desc: '分享您的智慧，与亲人保持联系，<br />享受安全、支持性的在线社区。',
  seniors_explore_btn: '探索功能',
  seniors_safety_btn: '加入社区',
  seniors_features_title: '您可以在FaceTrue上做什么',
  seniors_features_subtitle: '连接、分享和享受有意义的互动',
  seniors_feature1_title: '家庭联系',
  seniors_feature1_desc: '与全球家庭成员保持联系。在安全环境中分享照片、视频和生活更新。',
  seniors_feature2_title: '分享您的故事',
  seniors_feature2_desc: '与他人分享您的生活经历、智慧和回忆。您的故事很重要并能激励他人。',
  seniors_feature3_title: '结交新朋友',
  seniors_feature3_desc: '与分享您兴趣和爱好的人联系。建立有意义的友谊。',
  seniors_feature4_title: '本地活动',
  seniors_feature4_desc: '发现并参加您附近的本地社区活动、活动和聚会。',
  seniors_feature5_title: '学习新技能',
  seniors_feature5_desc: '访问有关技术、爱好和日常生活技能的教程、提示和指导。',
  seniors_feature6_title: '支持小组',
  seniors_feature6_desc: '加入健康、保健和生活挑战的支持社区。您并不孤单。',
  seniors_health_title: '健康与保健资源',
  seniors_health_subtitle: '通过可信信息保持知情和健康',
  seniors_health1_title: '健康提示',
  seniors_health1_desc: '为老年人量身定制的每日健康建议、营养提示和锻炼指导。',
  seniors_health2_title: '心理健康',
  seniors_health2_desc: '心理健康支持、正念练习和压力管理。',
  seniors_health3_title: '药物提醒',
  seniors_health3_desc: '设置药物和健康预约提醒以保持正轨。',
  seniors_health4_title: '活动跟踪',
  seniors_health4_desc: '跟踪您的日常活动、步数并庆祝您的健康里程碑。',
  seniors_community_title: '与您的社区联系',
  seniors_community_subtitle: '寻找支持、分享经验并建立有意义的联系',
  seniors_community_family: '家庭联系',
  seniors_community_family_desc: '与家人保持亲密',
  seniors_community_stories: '分享您的故事',
  seniors_community_stories_desc: '生活经历和智慧',
  seniors_community_friends: '结交新朋友',
  seniors_community_friends_desc: '与全球同龄人联系',
  seniors_community_events: '本地活动',
  seniors_community_events_desc: '社区活动和聚会',
  seniors_community_learning: '学习新技能',
  seniors_community_learning_desc: '永不停止成长和学习',
  seniors_community_support: '支持小组',
  seniors_community_support_desc: '寻找理解和鼓励',
  seniors_community_join_btn: '加入社区',
  seniors_benefits_title: '为什么老年人喜爱FaceTrue',
  seniors_benefits_subtitle: '尊重和重视您经验的社交网络',
  seniors_benefit1_title: '无诈骗或欺诈',
  seniors_benefit1_desc: 'AI保护防止诈骗者和欺诈活动。',
  seniors_benefit2_title: '大而清晰的文字',
  seniors_benefit2_desc: '易于阅读的界面，专为舒适观看而设计。',
  seniors_benefit3_title: '24/7支持',
  seniors_benefit3_desc: '当您需要帮助时，随时可获得帮助。',
  seniors_benefit4_title: '隐私保护',
  seniors_benefit4_desc: '您的个人信息始终保持安全和私密。',
  seniors_benefit5_title: '尊重的社区',
  seniors_benefit5_desc: '每个人都相互尊重的积极环境。',
  seniors_benefit6_title: '免费使用',
  seniors_benefit6_desc: '所有功能免费提供给您。',
  seniors_footer_copyright: '© 2025 FaceTrue老年人社区',
  seniors_footer_desc: '老年人连接的安全和支持空间',
};

export default common;
